/**
 * Resolve tenant/company display name from live API (never hardcode).
 * Falls back to JWT claims.tenant_code when needed.
 */
import { getSwaggerServiceBaseUrl, getJavaApiBaseUrl } from "../config/apiBase";

function decodeJwtPayload(token) {
  try {
    const parts = String(token || "").split(".");
    if (parts.length < 2) return null;
    const pad = "=".repeat((4 - (parts[1].length % 4)) % 4);
    const json = atob(parts[1].replace(/-/g, "+").replace(/_/g, "/") + pad);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function tenantHintFromStorage() {
  try {
    const details = JSON.parse(localStorage.getItem("zTaskUserDetails") || "{}");
    const fromUser =
      details.tenant?.displayName ||
      details.tenant?.legalName ||
      details.tenant?.tenantCode ||
      details.companyName ||
      details.tenantName ||
      "";
    if (fromUser) return String(fromUser);

    const token = localStorage.getItem("zTaskAuthToken") || "";
    const payload = decodeJwtPayload(token);
    const claims = payload?.claims || {};
    return (
      claims.tenant_code ||
      claims.tenantCode ||
      claims.displayName ||
      payload?.tenant_code ||
      ""
    );
  } catch {
    return "";
  }
}

function pickCompanyName(data) {
  if (!data || typeof data !== "object") return "";
  const list = data.message || data.messgae;
  const tenant = data.tenant || data.defaultTenant || {};
  if (Array.isArray(list) && list[0]) {
    const c = list[0];
    return (
      c.companyName ||
      c.company_name ||
      c.companyShortName ||
      c.companyKeyword ||
      c.company_abbr ||
      tenant.displayName ||
      tenant.legalName ||
      tenant.tenantCode ||
      ""
    );
  }
  if (typeof list === "string" && list && !/no companies/i.test(list)) {
    return list;
  }
  return tenant.displayName || tenant.legalName || tenant.tenantCode || "";
}

function pickLogo(data) {
  const list = data?.message || data?.messgae;
  if (Array.isArray(list) && list[0]) {
    return list[0].logoUrl || list[0].logo_url || null;
  }
  return null;
}

/**
 * @returns {Promise<{ name: string, logoUrl: string|null }>}
 */
export async function fetchTenantBranding() {
  const token = localStorage.getItem("zTaskAuthToken") || "";
  const hint = tenantHintFromStorage();
  if (!token) return { name: hint || "", logoUrl: null };

  const bases = [
    getSwaggerServiceBaseUrl(),
    getJavaApiBaseUrl(),
    process.env.REACT_APP_API_BASE_URL,
    process.env.REACT_APP_SWAGGER_SERVICE_BASE_URL,
  ]
    .map((b) => String(b || "").replace(/\/$/, ""))
    .filter(Boolean)
    .filter((b, i, arr) => arr.indexOf(b) === i);

  for (const base of bases) {
    try {
      const res = await fetch(`${base}/api/get-company`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Client": "web",
        },
      });
      if (!res.ok) continue;
      const data = await res.json();
      const name = pickCompanyName(data);
      if (name && String(name).toLowerCase() !== "null") {
        return { name: String(name), logoUrl: pickLogo(data) };
      }
    } catch {
      /* try next base */
    }
  }

  return { name: hint || "", logoUrl: null };
}
